import { graphql, SliceComponentProps } from "gatsby";
import React from "react";
import { SubscribeToNewsletterPopupSliceQuery } from "types/graphql-types";
import SliceProviders from "./SliceProviders";
import { SubscribeToNewsletterSliceContext } from "./types";
import ClientOnly from "components/ClientOnly";
import CustomPromoBanner from "components/CustomPromo/CustomPromoBanner/CustomPromoBanner";
import MaybeCustomPromoModal from "components/CustomPromo/CustomPromoModal/MaybeCustomPromoModal";

const CustomPromoComponentsSlice: React.FC<
  SliceComponentProps<
    SubscribeToNewsletterPopupSliceQuery,
    SubscribeToNewsletterSliceContext
  >
> = ({ data, sliceContext }) => {
  return (
    <SliceProviders languageCode={sliceContext.languageCode}>
      <CustomPromoBanner isBannerVisible={true} />
      <ClientOnly>
        <MaybeCustomPromoModal title={"YOUR EXCLUSIVE BENEFIT"} />
      </ClientOnly>
    </SliceProviders>
  );
};

export default CustomPromoComponentsSlice;
